













































import Vue from 'vue'
import Component from "vue-class-component";
import { Prop, Ref } from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import { getErrorMessage } from '@/utils/notify-helper';
import GoogleCaptcha from '@/components/reCAPTCHA';

@Component({components: {GoogleCaptcha}})
export default class registrationEmailForm extends Vue {
  @Ref('validator') validator:any;
  @Prop() email!: string;
  @Prop() sitekey!: string;
  @Getter("config") config: any;

  @Action("forgotPasswordSendLink") actionRequest: any;

  send = false
  form = {
    email: '',
  }

  async submit() {
    this.$emit('errorMessage', undefined)
    if (!await this.validator.validate()) {
      return
    }

    if (this.config.use_captcha) {
      //@ts-ignore
      this.form.googleToken = await this.$refs.captcha.generateToken();
    }

    this.$emit('isProgress', true)
    try {
      const resp = await this.actionRequest(this.form);
      this.send = true
    } catch (e) {
      const errorMessage = getErrorMessage(e)
      this.$emit('errorMessage', errorMessage)
    } finally {
      this.$emit('isProgress', false)
    }
  }

  back() {
    this.$emit('form', 'loginForm')
  }

}
